import { getAuth, provideAuth } from '@angular/fire/auth';
import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ModuleWithProviders } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { FirebaseOptions, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

export const FIREBASE_CONFIG = new InjectionToken<FirebaseOptions>('firebase.config');

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        FormsModule,
        provideFirebaseApp((injector) => initializeApp(injector.get(FIREBASE_CONFIG))),
        provideAuth(() => getAuth()),
        provideDatabase(() => getDatabase()),
        provideStorage(() => getStorage()),
        provideFirestore(() => getFirestore()),
    ]
})
export class MotesSdkModule {
    // Ensure that only one instance of login service is instantiated
    static forRoot(firebaseConfig: FirebaseOptions): ModuleWithProviders<MotesSdkModule> {
        return {
            ngModule: MotesSdkModule,
            providers: [
                DeviceDetectorService,
                DatePipe,
                // This is the new custom firebase config provider
                { provide: FIREBASE_CONFIG, useValue: firebaseConfig },
            ]
        };
    }
}
